@if (documentUrl) {
<div class="insurance-document">
  @if (fileType === FileType.PDF) {
  <div class="pdf-container">
    <iframe [src]="documentUrl" type="application/pdf" frameborder="0">
    </iframe>
  </div>
  } @else {
  <div class="image-container">
    <img [src]="documentUrl" alt="Document" />
  </div>
  }

  <div class="download-overlay">
    <button mat-icon-button (click)="downloadDocument()">
      <mat-icon>download</mat-icon>
    </button>
  </div>
</div>
}
